// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reviewRating.error,.reviewRating.error+p{margin-bottom:2rem!important}", "",{"version":3,"sources":["webpack://./resources/js/componets/ReviewRating.vue"],"names":[],"mappings":"AAAkD,0CAAsB,4BAMxE","sourcesContent":[".reviewRating.error{margin-bottom:2rem !important}.reviewRating.error+p{margin-bottom:2rem !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
